import { render, staticRenderFns } from "./message-list-content.vue?vue&type=template&id=4caa312a&scoped=true"
import script from "./message-list-content.vue?vue&type=script&lang=js"
export * from "./message-list-content.vue?vue&type=script&lang=js"
import style0 from "./message-list-content.vue?vue&type=style&index=0&id=4caa312a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa312a",
  null
  
)

export default component.exports